import AuthLayout from '~/components/organisms/auth/AuthLayout/AuthLayout';
import SignUpForm from '~/components/organisms/auth/SignUpForm/SignUpForm';

export default function SignUp() {
  return (
    <AuthLayout isSlider>
      <SignUpForm />
    </AuthLayout>
  );
}
